import React, { useState } from 'react';
import { useAuth } from './App';
import axios from 'axios';
import PartnerBenefitsShowcase from './components/PartnerBenefitsShowcase';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ahobilam.com';
const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;

const PartnerRegistrationPage = () => {
  const { language } = useAuth();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    whatsapp: '',
    age: '',
    city: '',
    area: '',
    address: '',
    idProof: '',
    academicQualification: '',
    expectedSalary: '',
    languagesKnown: '',
    transportMode: '',
    experience: '',
    mainSect: '',
    subSect: '',
    otherSubSect: '',
    
    roles: [],
    
    vedaPanditLevel: '',
    otherVedaPanditLevel: '',
    
    vadhyarVedam: '',
    vadhyarSkills: { poorvam: false, aparam: false, shradham: false, tarpanam: false },
    otherVadhyarSkills: '',
    
    bokthaSect: '',
    bokthaSubSect: '',
    
    driverTransportType: '',
    
    otherServiceDetails: '',
    expectations: '',
    volunteerHelpPlan: '',

    agreeTerms: false
  });
  
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const availableRoles = [
    { id: 'vadhyar', label_en: 'Vadhyar / Purohit', label_ta: 'வாத்தியார் / புரோகிதர்' },
    { id: 'cook', label_en: 'Cook / Thaligai', label_ta: 'சமையல் சுவாமிகள் / தளிகை' },
    { id: 'veda_pandit', label_en: 'Veda Pandit', label_ta: 'வேத பண்டிதர்' },
    { id: 'assistant_male', label_en: 'Vaideeka Assistant (Male)', label_ta: 'வைதீக உதவியாளர் (ஆண்)' },
    { id: 'assistant_female', label_en: 'Catering Assistant (Female)', label_ta: 'சமையல் உதவியாளர் (பெண்)' },
    { id: 'boktha', label_en: 'Male Boktha / Swamigal', label_ta: 'போக்தா / சுவாமிகள் (ஆண்)' },
    { id: 'driver', label_en: 'Driver', label_ta: 'ஓட்டுநர்' },
    { id: 'volunteer_guide', label_en: 'Community Volunteer / Guide', label_ta: 'தொண்டர் / சமூக வழிகாட்டி' },
    { id: 'other', label_en: 'Other Service', label_ta: 'மற்ற சேவைகள்' }
  ];

  const sectOptions = ['Iyer', 'Iyyangar', 'Madhva', 'Other'];
  const subSectOptions = {
    'Iyer': ['Vadama', 'Vathima', 'Brahacharanam', 'Other'],
    'Iyyangar': ['Vada Kalai', 'Then kalai', 'Other']
  };

  const transportOptions = ['Public Transport', '2 Wheeler', '4 Wheeler'];

  const handleRoleChange = (roleId) => {
    setFormData(prev => {
      const roles = prev.roles.includes(roleId)
        ? prev.roles.filter(r => r !== roleId)
        : [...prev.roles, roleId];
      return { ...prev, roles };
    });
  };

  const handleVadhyarSkillChange = (skill) => {
    setFormData(prev => ({
      ...prev,
      vadhyarSkills: {
        ...prev.vadhyarSkills,
        [skill]: !prev.vadhyarSkills[skill]
      }
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.agreeTerms) {
      alert(language === 'en' ? 'Please agree to the terms and conditions.' : 'தயவுசெய்து விதிமுறைகளை ஏற்கவும்.');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/partners/register`, formData);
      setSubmitted(true);
      setLoading(false);
    } catch (err) {
      console.error(err);
      alert(language === 'en' ? 'Error submitting form. Please try again later.' : 'தகவலைச் சமர்ப்பிப்பதில் பிழை. பின்னர் மீண்டும் முயற்சிக்கவும்.');
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-green-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-2xl text-center border-t-4 border-green-600">
          <div className="text-6xl mb-4">🙏</div>
          <h2 className="text-3xl font-bold text-green-800 mb-4">
            {language === 'en' ? 'Registration Successful!' : 'பதிவு வெற்றிகரமாக முடிந்தது!'}
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            {language === 'en'
              ? 'Thank you for registering with Ahobilam as a service partner. We will contact you when suitable opportunities arise.'
              : 'அஹோபிலம் தளத்தில் சேவைப் பணியாளராகப் பதிவு செய்ததற்கு நன்றி. தங்களுக்கு ஏற்ற வேலைவாய்ப்புகள் வரும்போது நாங்கள் உங்களைத் தொடர்புகொள்வோம்.'}
          </p>
          <button 
            onClick={() => window.location.href = '/'}
            className="bg-green-600 text-white px-8 py-3 rounded-full hover:bg-green-700 font-bold transition"
          >
            {language === 'en' ? 'Back to Home' : 'முகப்புப் பக்கத்திற்குச் செல்'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-yellow-50 py-12 px-4 sm:px-6">
      <div className="max-w-5xl mx-auto">
        <PartnerBenefitsShowcase />

        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          {/* Important Notice Section */}
          <div className="bg-orange-100 border-l-4 border-orange-600 p-6 md:p-8">
            <h3 className="text-xl font-bold text-orange-800 mb-4 flex items-center">
              <span className="text-2xl mr-2">⚠️</span> 
              {language === 'en' ? 'Important Notice & Terms' : 'முக்கிய நிபந்தனைகள் (Terms & Conditions)'}
            </h3>
            <div className="text-sm md:text-base text-gray-800 space-y-4 leading-relaxed text-justify">
              {language === 'ta' ? (
                <>
                  <p><strong>1. கட்டணம் இல்லை:</strong> இந்தப் பதிவிற்கோ அல்லது பணியைப் பெறவோ நீங்கள் எந்தக் கட்டணமும் செலுத்தத் தேவையில்லை. முற்றிலும் இலவசம்.</p>
                  <p><strong>2. வேலை வாய்ப்பு தகவல்:</strong> வாடிக்கையாளர் யாராவது தங்களைப் போன்ற பணிக்கு ஆள் தேடி எங்களிடம் விண்ணப்பித்தால், அது சம்பந்தமான வேலை, தேதி, நேரம், சேவைக்கான கட்டண விபரம், சேவை செய்ய வேண்டிய பகுதி (முழு முகவரி ஒப்பந்தத்திற்குப் பிறகு தரப்படும்) ஆகியவை உங்களுக்கு வாட்ஸ்அப்/குறுஞ்செய்தியாக அனுப்பப்படும்.</p>
                  <p><strong>3. ஒப்புதல் அளித்தல்:</strong> அனைத்தும் உங்களுக்கு ஏற்புடையதாக இருந்தால் <em>"ஒப்புக்கொள்கிறேன்"</em> அல்லது <em>"நிராகரிக்கிறேன்"</em> என்பதை நீங்கள் கிளிக் செய்து பதில் அனுப்பலாம்.</p>
                  <p><strong>4. நேரடித் தொடர்பு:</strong> உங்களது ஒப்புதல் சேவை தேவைப்படுவோருக்கு அனுப்பப்படும். அவர் உங்களைத் தேர்ந்தெடுத்தால், அவரே நேரில் உங்களைத் தொடர்புகொண்டு மற்ற விபரங்களைத் தெரிவிப்பார்.</p>
                  <p className="text-red-700 font-bold bg-red-50 p-3 rounded mt-2 border border-red-200">
                    முக்கிய குறிப்பு: இதற்குப் பிறகு அனைத்தும் வாடிக்கையாளர் மற்றும் சேவையாளர் ஆகிய இருவருக்கும் இடையிலான நேரடி விஷயமாகும். மேற்கொண்டு எழும் எந்தவொரு பணப் பரிவர்த்தனைப் புகாரிலோ அல்லது முரண்பாடுகளிலோ நமது நிறுவனம் (Ahobilam.com) எந்தப் பொறுப்பும் ஏற்காது.
                  </p>
                </>
              ) : (
                <>
                  <p><strong>1. No Fees:</strong> You do not need to pay any fees to register or receive service opportunities. This is completely free.</p>
                  <p><strong>2. Job Notifications:</strong> When a customer requests a service matching your skills, you will receive a notification with the Date, Time, Remuneration, and General Area (full address provided after agreement).</p>
                  <p><strong>3. Acceptance:</strong> If the terms suit you, you can reply by clicking "Accept" or "Reject".</p>
                  <p><strong>4. Direct Contact:</strong> Your acceptance is sent to the customer. If they select you, they will contact you directly to finalize details.</p>
                  <p className="text-red-700 font-bold bg-red-50 p-3 rounded mt-2 border border-red-200">
                    Important Note: After this point, it is a direct agreement between the Customer and the Service Provider. Ahobilam.com takes no responsibility or liability for any disputes, payment issues, or complaints that may arise thereafter.
                  </p>
                </>
              )}
            </div>
          </div>

          <form onSubmit={handleSubmit} className="p-6 md:p-8 space-y-6">
            
            {/* 1. Personal & Contact Info */}
            <div className="mb-6 border-b pb-6">
                <h4 className="text-xl font-bold text-gray-800 mb-4">{language === 'en' ? 'Personal Details' : 'தனிப்பட்ட விவரங்கள்'}</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'Full Name' : 'முழுப் பெயர்'} *
                    </label>
                    <input type="text" required value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                    placeholder={language === 'en' ? 'Enter your name' : 'உங்கள் பெயர்'} />
                </div>
                <div>
                    <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'Age' : 'வயது'} *
                    </label>
                    <input type="number" required value={formData.age} onChange={e => setFormData({...formData, age: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none" placeholder="e.g. 45" />
                </div>
                <div>
                    <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'Phone Number' : 'மொபைல் எண்'} *
                    </label>
                    <input type="tel" required value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none" placeholder="10 digit number" />
                </div>
                <div>
                    <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'WhatsApp Number' : 'வாட்ஸ்அப் எண்'}
                    </label>
                    <input type="tel" value={formData.whatsapp} onChange={e => setFormData({...formData, whatsapp: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
                    placeholder={language === 'en' ? 'Same as above if blank' : 'மொபைல் எண் போன்றதே எனில் காலியாக விடவும்'} />
                </div>
                <div>
                    <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'ID Proof' : 'அடையாள அட்டை (ID Proof)'} *
                    </label>
                    <input type="text" required value={formData.idProof} onChange={e => setFormData({...formData, idProof: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                    placeholder="e.g. Aadhaar, PAN, Voter ID, Driving License" />
                </div>
                <div>
                    <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'Languages Known' : 'தெரிந்த மொழிகள்'} *
                    </label>
                    <input type="text" required value={formData.languagesKnown} onChange={e => setFormData({...formData, languagesKnown: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                    placeholder="Tamil, English, Sanskrit, etc." />
                </div>
                </div>
            </div>

            {/* 2. Address & Logistics */}
            <div className="mb-6 border-b pb-6">
                <h4 className="text-xl font-bold text-gray-800 mb-4">{language === 'en' ? 'Location & Transport' : 'இடம் மற்றும் போக்குவரத்து'}</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'City' : 'நகரம் / மாவட்டம்'} *
                    </label>
                    <input type="text" required value={formData.city} onChange={e => setFormData({...formData, city: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none" placeholder="e.g. Chennai" />
                </div>
                <div>
                    <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'Local Area' : 'பகுதி (Local Area)'} *
                    </label>
                    <input type="text" required value={formData.area} onChange={e => setFormData({...formData, area: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none" placeholder="e.g. Mylapore, West Mambalam" />
                </div>
                <div className="md:col-span-2">
                    <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'Full Address' : 'முழு முகவரி'} *
                    </label>
                    <textarea required value={formData.address} onChange={e => setFormData({...formData, address: e.target.value})} rows="3"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none" placeholder="Enter your full address" />
                </div>
                <div>
                    <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'Mode of Transport' : 'போக்குவரத்து முறை'} *
                    </label>
                    <select value={formData.transportMode} required onChange={e => setFormData({...formData, transportMode: e.target.value})} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none bg-white">
                    <option value="">-- Select --</option>
                    {transportOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                    </select>
                </div>
                </div>
            </div>

            {/* 3. Sect Information */}
            <div className="mb-6 border-b pb-6">
                <h4 className="text-xl font-bold text-gray-800 mb-4">{language === 'en' ? 'Sect Information' : 'பிரிவு விவரங்கள்'}</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label className="block text-gray-700 font-bold mb-2">Main Sect *</label>
                    <select required value={formData.mainSect} onChange={e => setFormData({...formData, mainSect: e.target.value, subSect: ''})} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none bg-white">
                    <option value="">-- Select Main Sect --</option>
                    {sectOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                    </select>
                </div>
                {formData.mainSect && (formData.mainSect === 'Iyer' || formData.mainSect === 'Iyyangar') && (
                    <div>
                    <label className="block text-gray-700 font-bold mb-2">Sub Sect *</label>
                    <select required value={formData.subSect} onChange={e => setFormData({...formData, subSect: e.target.value})} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none bg-white">
                        <option value="">-- Select Sub Sect --</option>
                        {subSectOptions[formData.mainSect].map(opt => <option key={opt} value={opt}>{opt}</option>)}
                    </select>
                    </div>
                )}
                {((formData.mainSect && (formData.mainSect !== 'Iyer' && formData.mainSect !== 'Iyyangar')) || formData.subSect === 'Other') && (
                    <div>
                    <label className="block text-gray-700 font-bold mb-2">Please Mention Sect/Sub Sect *</label>
                    <input type="text" required value={formData.otherSubSect} onChange={e => setFormData({...formData, otherSubSect: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none" />
                    </div>
                )}
                </div>
            </div>

            {/* 4. Professional Information */}
            <div className="mb-6 border-b pb-6">
                <h4 className="text-xl font-bold text-gray-800 mb-4">{language === 'en' ? 'Professional Details' : 'தொழில் விவரங்கள்'}</h4>
                <div className="grid grid-cols-1 gap-6">
                <div>
                    <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'Academic and Vedic Qualification' : 'கல்வி மற்றும் வேத தகுதி'} *
                    </label>
                    <textarea required value={formData.academicQualification} onChange={e => setFormData({...formData, academicQualification: e.target.value})} rows="2"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none" placeholder="Fill your qualifications..." />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                    <label className="block text-gray-700 font-bold mb-2">
                        {language === 'en' ? 'Years of Experience' : 'பணி அனுபவம் (வருடங்களில்)'} *
                    </label>
                    <input type="text" required value={formData.experience} onChange={e => setFormData({...formData, experience: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none" placeholder="e.g. 10 Years" />
                    </div>
                    <div>
                    <label className="block text-gray-700 font-bold mb-2">
                        {language === 'en' ? 'Expected Salary / Remuneration' : 'எதிர்பார்க்கும் சம்பளம் / கட்டணம்'} *
                    </label>
                    <input type="text" required value={formData.expectedSalary} onChange={e => setFormData({...formData, expectedSalary: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none" placeholder="For max 8 hours (mention conveyance if extra)" />
                    </div>
                </div>
                <div className="mt-6">
                    <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'What are your expectations from us/customers?' : 'வாடிக்கையாளர் / எங்களிடம் உங்கள் எதிர்பார்ப்புகள் என்ன?'}
                    </label>
                    <textarea value={formData.expectations} onChange={e => setFormData({...formData, expectations: e.target.value})} rows="2"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none" 
                    placeholder={language === 'en' ? 'e.g., Flexible timings, specific travel arrangements, food preferences...' : 'உங்கள் நிபந்தனைகள் அல்லது எதிர்பார்ப்புகள்...'} />
                </div>
                </div>
            </div>

            {/* Role Selection */}
            <div className="pt-4 pb-6 border-b">
              <label className="block text-gray-800 text-lg font-bold mb-4">
                {language === 'en' ? 'Select the Services You Provide (can select multiple):' : 'நீங்கள் செய்யும் பணிகளைத் தேர்ந்தெடுக்கவும் (ஒன்றுக்கு மேற்பட்டவை தேர்வு செய்யலாம்):'} *
              </label>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {availableRoles.map(role => (
                  <label key={role.id} className={`flex items-center p-4 border rounded-lg cursor-pointer transition-colors ${formData.roles.includes(role.id) ? 'bg-orange-100 border-orange-500' : 'hover:bg-gray-50'}`}>
                    <input
                      type="checkbox"
                      checked={formData.roles.includes(role.id)}
                      onChange={() => handleRoleChange(role.id)}
                      className="w-5 h-5 text-orange-600 rounded mr-3"
                    />
                    <span className="font-medium text-gray-800">
                      {language === 'en' ? role.label_en : role.label_ta}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            {/* 5. Conditional Service Specific Details */}
            {formData.roles.length > 0 && (
                <div className="bg-orange-50 p-6 rounded-xl border border-orange-200 mb-6 space-y-6">
                    <h4 className="text-xl font-bold text-orange-800 mb-2">{language === 'en' ? 'Service Specific Information' : 'சேவை சார்ந்த தகவல்கள்'}</h4>
                    
                    {formData.roles.includes('veda_pandit') && (
                        <div className="bg-white p-4 rounded-lg shadow-sm">
                            <label className="block text-gray-800 font-bold mb-2">Veda Pandit - Level of Adhyayanam *</label>
                            <select value={formData.vedaPanditLevel} onChange={e => setFormData({...formData, vedaPanditLevel: e.target.value})} className="w-full md:w-1/2 px-4 py-2 border border-gray-300 rounded-lg outline-none bg-white mb-2">
                                <option value="">-- Select --</option>
                                <option value="Ganapaadi">Ganapaadi</option>
                                <option value="Krama paadi">Krama paadi</option>
                                <option value="Other">Other</option>
                            </select>
                            {formData.vedaPanditLevel === 'Other' && (
                                <input type="text" placeholder="Mention level" value={formData.otherVedaPanditLevel} onChange={e => setFormData({...formData, otherVedaPanditLevel: e.target.value})} className="w-full md:w-1/2 px-4 py-2 border border-gray-300 rounded-lg outline-none" />
                            )}
                        </div>
                    )}

                    {formData.roles.includes('vadhyar') && (
                        <div className="bg-white p-4 rounded-lg shadow-sm">
                            <label className="block text-gray-800 font-bold mb-2">Vadhyar / Purohit - Vedam Applicable *</label>
                            <select value={formData.vadhyarVedam} onChange={e => setFormData({...formData, vadhyarVedam: e.target.value})} className="w-full md:w-1/2 px-4 py-2 border border-gray-300 rounded-lg outline-none bg-white mb-4">
                                <option value="">-- Select Vedam --</option>
                                <option value="Apastambam">Apastambam (Yajur)</option>
                                <option value="Drahyayanam">Drahyayanam (Sama)</option>
                                <option value="Asvalayanam">Asvalayanam (Rig)</option>
                                <option value="Bodhyanam">Bodhyanam (Yajur)</option>
                            </select>

                            <label className="block text-gray-800 font-bold mb-2">Vadhyar Skills (Select all that apply) *</label>
                            <div className="flex flex-wrap gap-4 mb-3">
                                {['poorvam', 'aparam', 'shradham', 'tarpanam'].map(skill => (
                                    <label key={skill} className="flex items-center cursor-pointer">
                                        <input type="checkbox" checked={formData.vadhyarSkills[skill]} onChange={() => handleVadhyarSkillChange(skill)} className="w-4 h-4 text-orange-600 rounded mr-2" />
                                        <span className="capitalize">{skill}</span>
                                    </label>
                                ))}
                            </div>
                            <input type="text" placeholder="Or mention other specific skills" value={formData.otherVadhyarSkills} onChange={e => setFormData({...formData, otherVadhyarSkills: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg outline-none" />
                        </div>
                    )}

                    {formData.roles.includes('boktha') && (
                        <div className="bg-white p-4 rounded-lg shadow-sm">
                            <label className="block text-gray-800 font-bold mb-2">Boktha / Swamigal - Specific Sect & Sub-sect</label>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <input type="text" placeholder="Boktha Sect" value={formData.bokthaSect} onChange={e => setFormData({...formData, bokthaSect: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg outline-none" />
                                <input type="text" placeholder="Boktha Sub-sect" value={formData.bokthaSubSect} onChange={e => setFormData({...formData, bokthaSubSect: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg outline-none" />
                            </div>
                        </div>
                    )}

                    {formData.roles.includes('driver') && (
                        <div className="bg-white p-4 rounded-lg shadow-sm">
                            <label className="block text-gray-800 font-bold mb-2">Driver Details</label>
                            <textarea placeholder="Type of transport you own/drive and license information..." value={formData.driverTransportType} onChange={e => setFormData({...formData, driverTransportType: e.target.value})} rows="2" className="w-full px-4 py-2 border border-gray-300 rounded-lg outline-none" />
                        </div>
                    )}

                    {formData.roles.includes('volunteer_guide') && (
                        <div className="bg-white p-4 rounded-lg shadow-sm border-l-4 border-green-500">
                            <label className="block text-green-800 font-bold mb-2 flex items-center">
                              <span className="text-xl mr-2">🤝</span> Volunteer Guide Details
                            </label>
                            <p className="text-sm text-gray-600 mb-3">Thank you for stepping up to help the community! As a guide, you don't need to provide services yourself, but you can recommend trusted providers to others.</p>
                            <textarea placeholder="How do you plan to help? (e.g., I know many good cooks in Mylapore and can refer them...)" value={formData.volunteerHelpPlan} onChange={e => setFormData({...formData, volunteerHelpPlan: e.target.value})} rows="2" className="w-full px-4 py-2 border border-green-300 rounded-lg outline-none focus:ring-2 focus:ring-green-500" />
                        </div>
                    )}

                    {formData.roles.includes('other') && (
                        <div className="bg-white p-4 rounded-lg shadow-sm">
                            <label className="block text-gray-800 font-bold mb-2">Other Services / Helpers</label>
                            <p className="text-sm text-gray-600 mb-2">e.g., Two wheeler Assistant, Courier service, Parcel service, Vaideeka suppliers, Servers, etc.</p>
                            <textarea placeholder="Describe the type of service you provide and your expectations from us..." value={formData.otherServiceDetails} onChange={e => setFormData({...formData, otherServiceDetails: e.target.value})} rows="3" className="w-full px-4 py-2 border border-gray-300 rounded-lg outline-none" />
                        </div>
                    )}
                </div>
            )}

            {/* Agreement Checkbox */}
            <div className="pt-6 border-t">
              <label className="flex items-start cursor-pointer group">
                <input
                  type="checkbox"
                  required
                  checked={formData.agreeTerms}
                  onChange={e => setFormData({...formData, agreeTerms: e.target.checked})}
                  className="mt-1 w-6 h-6 text-green-600 rounded border-gray-300 mr-4 cursor-pointer"
                />
                <span className="text-gray-800 font-semibold group-hover:text-black">
                  {language === 'en' 
                    ? 'I have read and agree to all the terms and conditions mentioned above.' 
                    : 'மேலே குறிப்பிடப்பட்டுள்ள அனைத்து நிபந்தனைகளையும் படித்துப் புரிந்துகொண்டு ஒப்புக்கொள்கிறேன்.'}
                </span>
              </label>
            </div>

            <button
              type="submit"
              disabled={loading || formData.roles.length === 0 || !formData.agreeTerms}
              className="w-full bg-orange-600 text-white py-4 rounded-xl hover:bg-orange-700 font-bold text-xl disabled:bg-gray-400 disabled:cursor-not-allowed transition shadow-lg mt-8"
            >
              {loading 
                ? (language === 'en' ? 'Submitting...' : 'சமர்ப்பிக்கப்படுகிறது...') 
                : (language === 'en' ? 'Submit Registration' : 'விண்ணப்பத்தைச் சமர்ப்பி')}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PartnerRegistrationPage;
